/* Imports */
import { cva, type VariantProps } from "class-variance-authority";

/* Utils */
import { cn } from "@/utils/classes";

/* Styles */
const variants = cva("skeleton rounded-md", {
  variants: {
    variant: {
      h1: "h-7 min-w-20",
      h2: "h-6 min-w-16",
      h3: "h-5 min-w-12",
      p: "h-5 min-w-8",
      small: "h-4 min-w-4",
    },
  },
  defaultVariants: {
    variant: "p",
  },
});

/* Prop Types */
interface TextSkeletonProps extends VariantProps<typeof variants> {
  className?: string;
}

/* Text skeleton component */
export const TextSkeleton = ({ variant, className }: TextSkeletonProps) => {
  return <div className={cn(variants({ variant }), className)}></div>;
};
